import {
  computed,
  provide,
  inject,
  ComputedRef,
  ref,
  reactive,
  onMounted,
  onUnmounted
} from "vue";
import {
  watchEffect,
  EventBusListeners,
  State,
  applyMiddleware,
  combineReducers,
  exceptionLoggerMiddleware,
  executeTimeLoggerMiddleware,
  getNestedValue,
  setNestedValue,
  stateLoggerMiddleware,
  mergeObjectDeep,
  isJustObject
} from "@zyzgroup/core-common";
import {
  Context,
  closeLog,
  openLog,
  ColorPattern,
  getTheme$,
  useLocalStorage,
  WebMonitor
} from "@zyzgroup/core-web";
import parkReducer from "./store/reducers/parkReducer";
import lotReducer from "./store/reducers/lotReducer";
import billReducer from "./store/reducers/billReducer";
import orderReducer from "./store/reducers/orderReducer";
import plateReducer from "./store/reducers/plateReducer";
import groupReducer from "./store/reducers/groupReducer";
import userReducer from "./store/reducers/userReducer";
import resultReducer from "./store/reducers/resultReducer";
import themeReducer from "./store/reducers/themeReducer";
import colorReducer from "./store/reducers/colorReducer";
export { getColors } from "./store/reducers/colorReducer";

export { Context } from "@zyzgroup/core-web";

export interface ContextEventBusListeners extends EventBusListeners {
  globalResize: (width: number, height: number) => void;
}

// closeLog();
openLog();

const wm = new WebMonitor({ appId: "xg", checkWhiteScreen: true });

const immutable = true; // 不可变的
// const immutable = false; // 可变的

const INIT_STATE = {
  theme: {
    theme: "light"
  },
  color: {
    colorPattern: "xg-blue"
  }
};

// 全局 Context
export const context = new Context<ContextEventBusListeners>({
  store: {
    state: INIT_STATE,
    reducer: combineReducers(
      {
        park: parkReducer(immutable),
        lot: lotReducer(immutable),
        bill: billReducer(immutable),
        order: orderReducer(immutable),
        plate: plateReducer(immutable),
        group: groupReducer(immutable),
        user: userReducer(immutable),
        result: resultReducer(immutable),
        theme: themeReducer(immutable),
        color: colorReducer(immutable)
      },
      immutable
    ),
    enhancer: applyMiddleware(
      // stateLoggerMiddleware,
      exceptionLoggerMiddleware,
      executeTimeLoggerMiddleware
    ),
    immutable
  },
  axios: {
    baseURL: "https://test.xinge.me",
    // baseURL: "https://xinge.ruolin-link.com",
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    }
  },
  static: {
    token: useLocalStorage("xg-token"),
    hotline: "400-158-8363"
  }
});

// provide<Context<ContextEventBusListeners>>("context", context);
// const context = inject<Context<ContextEventBusListeners>>("context");
// const context = inject<Context>("context");

console.log(context.store.getState());
const stateReactive: ReturnType<typeof reactive<State>> = reactive(
  context.store.getState()
);

context.store.subscribe((change) => {
  if (immutable) {
    console.log("subscribe immutable", change);
    setNestedValue(stateReactive, change.path, change.newValue);
  } else {
    // console.log("subscribe mutable", change);
    if (isJustObject(change.newValue)) {
      // state 特性：值不可能为对象
      return;
    }
    console.log("subscribe mutable", change);
    // const newState = context.store.getState();
    // mergeObjectDeep(stateReactive, newState);
    setNestedValue(stateReactive, change.path, change.newValue);
  }
});

export function mapState(keys: string[]) {
  const mappedState: Record<string, ComputedRef<any>> = {};
  keys.forEach((key: string) => {
    mappedState[key] = computed(() => getNestedValue(stateReactive, key));
  });
  return mappedState;
}

export type Status = "success" | "error" | "info" | "waiting";

// 监听 theme 切换
getTheme$().subscribe((theme) => {
  // console.log("theme:", theme);
  context.store.dispatch({ type: "SET_THEME", payload: { theme } });
  context.store.dispatch({
    type: "SET_COLOR",
    payload: { colorPattern: context.store.getState().color.colorPattern }
  });
});
